/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TicketControllerDownloadOne$Params {
  id: number;

/**
 * Se 'mobile-app', il pdf generato include anche la soluzione del ticket
 */
  'x-client-platform'?: string;
}

export function ticketControllerDownloadOne(http: HttpClient, rootUrl: string, params: TicketControllerDownloadOne$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerDownloadOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('x-client-platform', params['x-client-platform'], {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

ticketControllerDownloadOne.PATH = '/ticket/{id}/download';
